<template>
  <uni-uploader
    :key="id"
    :title="title"
    :files="files"
    :accept="accept"
    :allowed-extensions="allowedExtensions"
    :upload-endpoint="uploadEndpoint"
    :stringify-last-modified="stringifyLastModified"
    :keep-uploaded="!hideControlButtons"
    :library="library"
    @uploaded="onUploaded"
    @removed="onRemoved"
  >
    <template #actions="scope">
      <slot
        name="actions"
        v-bind="scope"
      />
    </template>
  </uni-uploader>
</template>

<script>
import UniUploader from './uploader/UniUploader.vue'

/**
 * One file of a record (a poster, a logo, a document): `v-model` is the file's id, `default` the file the record has
 * now. Drag a file in, click or paste — it uploads at once. With `hide-control-buttons` the uploaded file does not
 * stay here: the page adds it to its own list (`@updatePhotos`).
 *
 * The props and events are the ones the pages have always used; the uploading itself is UniUploader.
 */
export default {
  name: 'FileUploader',
  components: { UniUploader },
  props: {
    title: { type: String, default: '' },
    /** a change of it resets the uploader (the same form reused for another record) */
    id: { type: String, default: undefined },
    /** the file's id (`v-model`) */
    value: { type: [Number, String, Object], default: null },
    /** the file object the record has now; some pages pass the id here — that is not a file to show */
    default: { type: [Object, Number, String], default: null },
    hideControlButtons: Boolean,
    accept: { type: String, default: '' },
    uploadEndpoint: { type: String, default: '/file/upload' },
    allowedExtensions: { type: Array, default: () => [] },
    stringifyLastModified: { type: Boolean, default: false },
  },
  computed: {
    /** the file library suits an ordinary file; a special endpoint (a GPX track) has its own rules */
    library() {
      return this.uploadEndpoint === '/file/upload' && !this.allowedExtensions.length
    },
    files() {
      const file = this.default
      return file && typeof file === 'object' && !this.hideControlButtons ? [file] : []
    },
  },
  methods: {
    onUploaded(file) {
      this.$emit('input', file.id)
      this.$emit('updatePhotos', file)
    },
    onRemoved() {
      this.$emit('input', null)
      this.$emit('updatePhotos', null)
    },

  },
}
</script>
